import { GlobalStoreCtx } from '@/stores/GlobalStore';
import { EN_APP_DEVICE } from '@/utils/functions/device';
import clsx from 'clsx';
import React, { createElement, useContext } from 'react';

import styles from './NavigationBarHeading.module.scss';

type NavigationBarHeadingChild =
  | string
  | {
      title: string | React.ReactNode;
      subs?: readonly string[];
    };

interface INavigationBarHeadingProps {
  /** 기본값 h1. 문맥 상 <h1>이 이상할 때 사용. */
  as?: 'h1' | 'p';
  children: NavigationBarHeadingChild;
  left?: boolean;
}

/**
 * 내비게이션 바에 맞춰 스타일을 적용한 페이지 제목. 부제목을 받을 수 있다.
 */
const NavigationBarHeading: React.FC<INavigationBarHeadingProps> = ({ as = 'h1', children, left }) => {
  const globalStore = useContext(GlobalStoreCtx);
  const isAndroid = globalStore.AppDevice === EN_APP_DEVICE.ANDROID;
  const cls = isAndroid ? styles.containerAndroid : styles.container;

  if (typeof children === 'string') {
    return (
      <div className={clsx(cls, left ? styles.left : null)}>
        {createElement(as, { className: styles.title }, children)}
      </div>
    );
  }

  if ('title' in children) {
    const titleStyle = children.subs ? styles.titleWithSub : styles.title;

    return (
      <div className={isAndroid ? styles.containerAndroid : styles.container}>
        {typeof children.title === 'string'
          ? createElement(as, { className: titleStyle }, children.title)
          : children.title}
        {children.subs && (
          <div className={styles.subs}>
            {children.subs.map((sub, idx) => (
              <span key={idx} className={styles.sub}>
                {sub}
              </span>
            ))}
          </div>
        )}
      </div>
    );
  }

  return null;
};

export default NavigationBarHeading;
